import React from "react";
import UserProfile from "components/UserProfile/UserProfile";
import { useEffect, useState } from "react";

import toast, { Toaster } from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import $ from "jquery";
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import { useDownloadExcel } from "react-export-table-to-excel";
import { useRef } from "react";
import NavOptions from "components/Options/NavOptions";
import UserHistoryModal from "components/OldOrders/UserHistoryModal";
import "assets/css/oldOrders.css";
import API from "components/Apis/API";

import { filterDirect } from "components/OldOrders/helpers";

import { BOLPrinter } from "components/Warehouse/modals/PrintBOL";
import { useDispatch } from "react-redux";

$.DataTable = require("datatables.net");

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Modal,
  Alert,
} from "react-bootstrap";
import { ordersApi } from "../components/Apis/orders";

const Orders = () => {
  const dispatch = useDispatch();
  const tableRef = useRef(null);

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCloseMx = () => setShowMx(false);
  const handleShowMx = () => setShowMx(true);

  const handleCloseProF = () => setShowProF(false);
  const handleShowProF = () => setShowProF(true);

  const [startDate, setStartDate] = useState(false);
  const [endDate, setEndDate] = useState(false);
  const [limit, setLimit] = useState("100");
  const [terminal, setTerminal] = useState("all");
  const [orderNoForm, setOrderNoForm] = useState(false);
  const [bus, setBus] = useState(false);
  const [busID, setBusID] = useState(false);
  const [status, setStatus] = useState(2);
  const [filterDate, setFilterDate] = useState("updated_at");
  const [mxStatus, setMxStatus] = useState("all");

  let history = useHistory();

  const [orders, setOrders] = useState([]);
  const [order, setOrder] = useState([]);
  const [dimensions, setDimensions] = useState([]);
  const [proF, setProF] = useState([]);
  const [isDirect, setIsDirect] = useState(false);

  const handleDirect = () => {
    if (isDirect) {
      fetchData();
      setIsDirect(false);
    } else {
      filterDirect(orders, setOrders);
      setIsDirect(true);
    }
  };

  const [statusObj, setArray] = useState({
    "En Route to Shipper": "12",
    "On-site at the Shipper": "25",
    "Loaded and En Route to Border": "37",
    "On-site at the Border": "50",
    Crossing: "62",
    "MX Customs": "75",
    "US Customs": "87",
    "MX Portion Completed": "100",
    Emergency: "0",
    Hold: "0",
    Cancelled: "0",
  });

  const [statusObjSb, setArraySb] = useState({
    "Service Reported To Broker": "12",
    "Unit At Broker. Waiting Doda": "35",
    "Doda Ready. Waiting For Transfer": "37",
    Crossing: "50",
    "At Nuevo Laredo. Waiting Dispatch": "62",
    "In Route To Destination": "75",
    "Arrived At Plant": "87",
    "MX Portion Completed": "100",
    Cancelled: "0",
  });

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));
  const location = useLocation();
  const queryParams = new URLSearchParams(window.location.search);

  const fetchData = async () => {
    const toastId = toast.loading("Loading data...");
    const url = "" + "admin/get_orders_old";
    const token = await UserProfile.getToken();

    let formData = new FormData();
    formData.append("terminal", terminal);
    formData.append("start_date", startDate);
    formData.append("end_date", endDate);
    formData.append("limit", limit);
    formData.append("order_no", orderNoForm);
    formData.append("bus", bus);
    formData.append("bus_id", busID);
    formData.append("status", status);
    formData.append("filter_date", filterDate);
    formData.append("mx_status", mxStatus);

    const response = await API.postData(url, formData);
    const data = response;

    setOrders(data);
    toast.dismiss(toastId);

    //init datatable
    //NavOptions.initDataTable(100);
  };


  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Orders - " + Math.floor(Date.now() / 1000),
    sheet: "Main",
  });
  // finish up the bus
  const askRestore = async (id) => {
    toast(
      (t) => (
        <span style={{ textAlign: "center" }}>
          Do you want to restore this order and remove it from the current bus?
          <br></br>
          <button
            className="btn btn-primary btn-xs"
            onClick={() => restoreOrder(t.id, id)}
          >
            Yes
          </button>
          <button
            className="btn btn-primary btn-xs"
            onClick={() => toast.dismiss(id.id)}
          >
            No
          </button>
        </span>
      ),
      { icon: "⚠️" }
    );
  };

  const restoreOrder = async (t, id) => {
    const url = "" + "admin/restore_order";
    const token = await UserProfile.getToken();

    let formData = new FormData();
    formData.append("id", id);
    const response = await API.postData(url, formData);
    const rsp = response;
    if (rsp.status) {
      toast.dismiss(t.id);
      toast.success("Order restored!");
    } else {
      toast.dismiss(t.id);
      toast.error("Order failed to restore!");
    }
  };

  const [showUserHistory, setShowUserHistory] = useState(false);
  const [orderHistory, setOrderHistory] = useState(0);
  const handleUserHistory = (row) => {
    setShowUserHistory(true);
    setOrderHistory(row);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Toaster position="bottom-right" />
      <Container fluid className="auto-zoom">
        <Row>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">Search parameters</Card.Title>
              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <Row className="col-md-12 row">
                  <Col md="2">
                    <label>Date</label>
                    <select
                      name="filter_date"
                      className="form-control mt-1 modalInput"
                      onChange={(e) => {
                        setFilterDate(e.target.value);
                      }}
                    >
                      <option value="updated_at">Last Modified Date</option>
                      <option value="created_at">Created Date</option>
                      <option value="pickup_date">Pick Up Date</option>
                    </select>
                  </Col>
                  <Col md="2">
                    <label>Start Date</label>
                    <input
                      name="start_date"
                      type="date"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter order no"
                      onChange={(e) => {
                        setStartDate(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md="2">
                    <label>End Date</label>
                    <input
                      name="end_date"
                      type="date"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter order no"
                      onChange={(e) => {
                        setEndDate(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md="2">
                    <label>Terminal</label>
                    <select
                      name="terminal"
                      className="form-control mt-1 modalInput"
                      onChange={(e) => {
                        setTerminal(e.target.value);
                      }}
                    >
                      <option value="all">All</option>
                      <option value="1">LRD NBB</option>
                      <option value="2">CKV SBB</option>
                      <option value="3">CKV NBB</option>
                      <option value="4">DTW</option>
                      <option value="5">DTW SB</option>
                      <option value="5">0 Miles</option>
                      <option value="7">MX NB</option>
                      <option value="8">MX SB</option>
                      <option value="0">Others</option>
                    </select>
                  </Col>
                  <Col md="2">
                    <label>Records</label>
                    <select
                      name="terminal"
                      className="form-control mt-1 modalInput"
                      onChange={(e) => {
                        setLimit(e.target.value);
                      }}
                    >
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                      <option value="5000">5000</option>
                    </select>
                  </Col>
                  <Col md="2">
                    <label>Order No#</label>
                    <input
                      name="order_no"
                      type="text"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter order no"
                      onChange={(e) => {
                        setOrderNoForm(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md="2">
                    <label>Status</label>
                    <select
                      name="terminal"
                      className="form-control mt-1 modalInput"
                      onChange={(e) => {
                        setStatus(e.target.value);
                      }}
                    >
                      <option value="2">All</option>
                      <option value="1">Active</option>
                      <option value="0">Completed</option>
                    </select>
                  </Col>
                  <Col md="2">
                    <label>MX Status</label>
                    <select
                      onChange={(e) => {
                        setMxStatus(e.target.value);
                      }}
                      name="mx_status"
                      className="form-control mt-1 modalInput"
                    >
                      <option value="all">All</option>
                      {terminal == 7
                        ? Object.entries(statusObj).map(function (row, key) {
                          return <option>{row[0]}</option>;
                        })
                        : Object.entries(statusObjSb).map(function (row, key) {
                          return <option>{row[0]}</option>;
                        })}
                    </select>
                  </Col>
                  <Col md="2">
                    <label>Bus</label>
                    <input
                      name="bus_id"
                      type="text"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter Bus Name"
                      onChange={(e) => setBus(e.target.value)}
                    />
                  </Col>
                  <Col md="2">
                    <label>Bus ID</label>
                    <input
                      name="bus_id"
                      type="number"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter Bus ID"
                      onChange={(e) => setBusID(e.target.value)}
                    />
                  </Col>
                  <Col md="3">
                    <br></br>
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => fetchData()}
                    >
                      Search
                    </button>

                    <button
                      className="btn btn-primary btn-sm"
                      onClick={onDownload}
                    >
                      {" "}
                      Export excel{" "}
                    </button>
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={handleDirect}
                    >
                      {isDirect ? "All Orders" : "Direct Orders"}
                    </button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">Search result</Card.Title>
                <p className="card-category"></p>
              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <Table
                  className="table-hover table-striped oldOrders"
                  ref={tableRef}
                >
                  <thead>
                    <tr>
                      <th className="border-0">Pick Up Date</th>
                      <th className="border-0">Update By</th>
                      <th className="border-0">Modified Date</th>
                      <th className="border-0">Inbound</th>
                      <th className="border-0">MX Carrier</th>
                      {(terminal == "7") | (terminal == "8") ? (
                        <th className="border-0">MX Status</th>
                      ) : (
                        ""
                      )}
                      <th className="border-0">Trailer/Placas</th>
                      <th className="border-0">Pro (B)</th>
                      <th className="border-0">Bus</th>
                      <th className="border-0">Deliver To</th>
                      <th className="border-0">In Dock</th>
                      {/* changed below label from Bus No to outbound ticket CSS-492 */}
                      <th className="border-0">Outbound</th>
                      <th className="border-0">Stop</th>
                      <th className="border-0">Distance(mi)</th>
                      <th className="border-0">Drop Dead</th>
                      <th className="border-0">Reference No#</th>

                      <th className="border-0">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map((row, i) => (
                      <tr key={i}>
                        <td>{row.pickup_date}</td>
                        <td
                          onClick={() => handleUserHistory(row)}
                          style={{ cursor: "pointer" }}
                        >
                          {row.updated_name.split("@")[0]}
                        </td>
                        <td>{row.updated_at}</td>
                        <td>{row.inbound}</td>
                        <td>{row.mx_carrier}</td>
                        {(terminal == "7") | (terminal == "8") ? (
                          <td>{row.mx_status}</td>
                        ) : (
                          ""
                        )}
                        <td>{row.trailer_placas}</td>
                        <td>
                          {row.order_no} {row.order_group}
                        </td>
                        <td>
                          {row.bus} {row.bus_id}
                        </td>
                        <td>{row.deliver_to}</td>
                        <td className={row.dock == "Yes" ? "bgreen" : ""}>
                          {row.dock}
                        </td>
                        <td className={row.bus == 0 ? "cred" : ""}>
                          {row.bus}
                        </td>
                        <td>{row.stop}</td>
                        <td>{row.distance}</td>
                        <td>{row.drop_dead}</td>
                        <td>{row.customer_reference}</td>

                        <td>
                          <button
                            title="Archive Order"
                            className="btn btn-primary btn-xs"
                            onClick={() => {
                              ordersApi.archive(row.id)
                                .then(() => {
                                  toast.success("Order archived successfully!");
                                })
                                .catch((error) => {
                                  toast.error(
                                    `Error archiving order: ${error.response?.data?.msg || error.message}`
                                  );
                                });
                            }}
                          >
                            <i className="fa fa-archive"></i>
                          </button>
                          <button
                            className="btn btn-primary btn-xs"
                            onClick={() => askRestore(row.id)}
                          >
                            <i className="fa fa-reply"></i>
                          </button>
                          <BOLPrinter order={row} size={"btn-xs"} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <UserHistoryModal
        showUserHistory={showUserHistory}
        setShowUserHistory={setShowUserHistory}
        orderHistory={orderHistory}
      />
    </>
  );
};

export default Orders;
